import { Injectable } from '@angular/core';
import { Auth, signInWithPopup, signInWithRedirect, signOut, GoogleAuthProvider, authState, User } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // Observable que emite el usuario actual o null cuando cambia el estado de auth
  user$: Observable<User | null>;

  constructor(
    private auth: Auth,
    public router: Router
  ) {
    this.user$ = authState(this.auth);
  }

  // Usuario actual síncrono — disponible una vez que Firebase restaura la sesión
  get currentUser() {
    return this.auth.currentUser;
  }

  // Estado de sesión síncrono — usado por los guards
  get isLoggedIn(): boolean {
    return this.auth.currentUser !== null;
  }

  authGoogleAuth() {
    const provider = new GoogleAuthProvider();
    
    // En móvil usa redirect, en desktop usa popup
    if (this.isMobile()) {
      return signInWithRedirect(this.auth, provider);
    } else {
      return signInWithPopup(this.auth, provider);
    }
  }

  signOut() {
    return signOut(this.auth).then(() => {
      this.router.navigate(['/login']);
    });
  }

  // Detecta si el dispositivo es móvil
  private isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}
